import { useOutletContext, type NavigateFunction } from 'react-router';

export interface IdentifiantsEnAttente {
  readonly email: string;
  readonly motDePasse: string;
}

export interface ContexteConnexion {
  readonly identifiantsEnAttente: IdentifiantsEnAttente | null;
  readonly poserIdentifiantsEnAttente: (identifiants: IdentifiantsEnAttente | null) => void;
}

/**
 * État transitoire entre `/connexion` et `/connexion/2fa` : le second facteur
 * se vérifie en resoumettant `email` + `motDePasse` + le code
 * (`docs/dev/api.md` § 3, `POST /v1/auth/login`), il faut donc les deux mots
 * de passe en mémoire le temps de l'étape. Volontairement en mémoire, jamais
 * dans `sessionStorage` : un mot de passe ne doit pas survivre à un
 * rafraîchissement.
 */
export function useContexteConnexion(): ContexteConnexion {
  return useOutletContext<ContexteConnexion>();
}

/**
 * Navigation après une connexion réussie : si le routeur refuse la
 * destination (adresse externe, chemin invalide), l'utilisateur arrive sur
 * l'accueil au lieu de rester sur `/connexion` sans explication.
 */
export async function allerApresConnexion(
  navigate: NavigateFunction,
  retour: string,
): Promise<void> {
  try {
    await navigate(retour);
  } catch {
    await navigate('/');
  }
}
